import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from 'layouts/admin';
import StudentLayout from 'layouts/student';
import AuthLayout from 'layouts/auth';
import TeacherLayout from 'layouts/teacher';
import AccountantLayout from 'layouts/accountant/Index';
import PlacementLayout from 'layouts/placement/Index';
import HeadHRLayout from 'layouts/headhr';
import 'assets/css/Plugins.css';
import { useState, useEffect, useContext } from 'react';
import Alerts from 'views/admin/main/others/404';
import { AuthContext } from 'contexts/AuthContext';
import OrgForgotPassword from 'pages/PasswordReset/Org/Index';
import OrgResetPassword from 'pages/PasswordReset/Org/Reset';
import NoInternet from 'pages/Common/NoInternet';
import useScrollToTop from 'pages/Hooks/useScrollToTop';
import SuperAdminLayout from 'layouts/super-admin';
import TeacherUpdatePassword from 'pages/PasswordReset/Teacher/TeacherUpdatePassword';
import StudentUpdatePassword from 'pages/PasswordReset/Student/StudentUpdatePassword';
import DynamicTitle from 'components/sidebar/components/DynamicTitle';
import { TitleProvider } from 'contexts/TitleContext';
const defaultTheme = {
  '--background-100': '#FFFFFF',
  '--background-900': '#070f2e',
  '--shadow-100': 'rgba(112, 144, 176, 0.08)',
  '--color-50': '#E9E3FF',
  '--color-100': '#C0B8FE',
  '--color-200': '#A195FD',
  '--color-300': '#8171FC',
  '--color-400': '#7551FF',
  '--color-500': '#422AFB',
  '--color-600': '#3311DB',
  '--color-700': '#2111A5',
  '--color-800': '#190793',
  '--color-900': '#11047A',
};

const App = () => {
  const [themeApp, setThemeApp] = useState({
    ...defaultTheme,
    contrastMode: 'default',
  });
  const [mini, setMini] = useState(false);
  const { state, loading } = useContext(AuthContext);
  const userRole = state?.user?.role;
  const userHrRole = state?.user?.hrRole;

  const getEffectiveRole = () => {
    if (userRole === 'placement') {
      if (userHrRole === 'headhr' || userHrRole === 'jrhr') {
        return userHrRole;
      }
    }
    return userRole;
  };

  const effectiveRole = getEffectiveRole();
  useScrollToTop();

  useEffect(() => {
    const savedTheme = localStorage.getItem('themeApp');
    if (savedTheme) {
      const parsedTheme = JSON.parse(savedTheme);
      setThemeApp((prevTheme) => ({ ...prevTheme, ...parsedTheme }));
    }

    const savedMini = localStorage.getItem('mini');
    if (savedMini !== null) {
      setMini(JSON.parse(savedMini));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('themeApp', JSON.stringify(themeApp));
    Object.entries(themeApp).forEach(([key, value]) => {
      if (key !== 'contrastMode') {
        document.documentElement.style.setProperty(key, value);
      }
    });
  }, [themeApp]);

  useEffect(() => {
    localStorage.setItem('mini', JSON.stringify(mini));
  }, [mini]);

  return (
    <NoInternet>
      <TitleProvider>
        <DynamicTitle />
        <Routes>
          {effectiveRole === 'admin' && (
            <Route
              path="admin/*"
              element={
                <AdminLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}
          {effectiveRole === 'student' && (
            <Route
              path="student/*"
              element={
                <StudentLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}
          {effectiveRole === 'teacher' && (
            <Route
              path="teacher/*"
              element={
                <TeacherLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}
          {effectiveRole === 'account' && (
            <Route
              path="accountant/*"
              element={
                <AccountantLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}

          {effectiveRole === 'superadmin' && (
            <Route
              path="superadmin/*"
              element={
                <SuperAdminLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}

          {effectiveRole === 'placement' && (
            <Route
              path="placement/*"
              element={
                <PlacementLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}

          {(effectiveRole === 'headhr' || effectiveRole === 'jrhr') && (
            <Route
              path="headhr/*"
              element={
                <HeadHRLayout
                  setMini={setMini}
                  mini={mini}
                  theme={themeApp}
                  setTheme={setThemeApp}
                />
              }
            />
          )}

          <Route path="auth/*" element={<AuthLayout />} />
          <Route path="/" element={<Navigate to="/auth" replace />} />
          <Route path="*" element={<Alerts />} />

          {/* ResetPassword */}
          <Route
            path="/admin/forgot-password"
            element={<OrgForgotPassword />}
          />
          <Route
            path="/admin/password-reset/:token"
            element={<OrgResetPassword />}
          />
          <Route
            path="/teacher-update-password"
            element={<TeacherUpdatePassword />}
          />
          <Route
            path="/student-update-password"
            element={<StudentUpdatePassword />}
          />
        </Routes>
      </TitleProvider>
    </NoInternet>
  );
};

export default App;
